import {
  ApiTokenListResponse,
  CalendarEventOccurrenceAsMember,
  TokenPageableRequestParams,
} from "@gymflow/types";

import { createAxiosInstance } from "../createAxiosInstance";

export type PublicEventApiType = ReturnType<typeof publicEventApi>;

const publicEventApi = (apiUrl: string, clubId: number) => {
  const clubPrefix = `club/${clubId}/`;
  const apiInstance = createAxiosInstance({
    apiUrl,
  });
  return {
    calendarEventOccurrences({
      filters,
    }: {
      filters: {
        dateFrom: string;
        dateTo: string;
        includeBookedCounts?: boolean;
        includeWaitingCounts?: boolean;
        isPublicEvent?: boolean;
        eventHostId?: string[];
        facilityId?: number[];
        activityId?: number[];
        activityCategoryId?: number[];
      } & TokenPageableRequestParams;
    }) {
      return apiInstance.get<
        ApiTokenListResponse<CalendarEventOccurrenceAsMember>
      >(`${clubPrefix}hosted/calendar/event-occurrences`, {
        params: filters,
      });
    },
  };
};

export default publicEventApi;
